Number.isNaN = Number.isNaN || function(value) {
  return value !== value;
}


// WEBPACK FOOTER //
// ./src/common/general/js/polyfills/Number.isNan.js